// components/ItemsEditor/index.js
import ItemsEditor from './ItemsEditor'
import './ItemsEditor.css'

export default ItemsEditor
export { ItemsEditor }